import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6539277e")

_pushScopeId("data-v-6539277e")
const _hoisted_1 = {
  key: 0,
  class: "spinnerContainer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_mini_spinner = _resolveComponent("mini-spinner")!

  return (_ctx.showSpinner)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_mini_spinner)
      ]))
    : _createCommentVNode("", true)
})